import React from "react";
import { Navigate } from "react-router-dom";
import Main from "./Main";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("i_ems_employee_token");
  return token ? <Main>{children}</Main> : <Navigate to="/login" />;
};

export default PrivateRoute;
